import {Heading as ChakraHeading, HeadingProps} from "@chakra-ui/react";

const Heading = ({
  useShadow,
  useGradient,
  children,
  ...props
}: {useShadow?: boolean; useGradient?: boolean} & HeadingProps) => (
  <ChakraHeading
    letterSpacing="tight"
    textShadow={useShadow ? "0px 1px 2px rgba(0,0,0,.1)" : undefined}
    bgGradient={useGradient ? "linear-gradient(175deg, {colors.cyan.500}, {colors.blue.500})" : undefined}
    backgroundClip={useGradient ? "text" : undefined}
    position="relative"
    {...props}
  >
    {children}
  </ChakraHeading>
);

export default Heading;
